/**
 * Isolates `import.meta.env` so Vite can inline BASE_URL at build time
 * while Jest mocks this module.
 */
export const resolveViteBaseUrl = (): string => import.meta.env.BASE_URL || '/';
